import {useEffect, useRef, useState} from "react";
import {useForm} from "react-hook-form";
import {catValToTxt} from "../../utils/UtilsFunc";
import {useNavigate,useNavigationType} from "react-router-dom";
import {useWarnBeforeUnload} from "../../utils/policyUtils";
import Modals from "../Modals/Modals";
import {useApi} from "../../hooks/ApiProvider/ApiProvider";

const option = [
  {
    label:`계정`,
    value:`0`,
  },
  {
    label:`결제/ 환불/ 배송`,
    value:`1`,
  },
  {
    label:`오류 신고`,
    value:`2`,
  },
  {
    label:`기타`,
    value:`3`,
  },
];

const Form = ({...props}) => {
  const api = useApi();
  
  const {register
    ,setValue
    ,getValues
    ,formState
    ,watch
  } = useForm({mode:"onChange"})
  const [selectBox, setSelectBox] = useState(false);
  const [onSubmitForm, setOnSubmitForm] = useState<any>({
    category:`0`,
    imgs:[],
  });
  const fileBtnRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const getReady = async () => {
  
  }
  
  const onSelect = (ids:string) => {
    console.log(`123123123`)
    setOnSubmitForm({...onSubmitForm,category:ids});
  }
  const uploadFiles = (filelist:any) => {
    let temp = Array.from(filelist)?.filter((val:any,idx:any)=>5 > idx && (val?.type === 'image/png' || val?.type === 'image/jpeg'));
    console.log(temp);
    setOnSubmitForm({...onSubmitForm,imgs:temp})
  }
  
  const onDelThum = (name:any, idx:any) => {
    console.log(`썸네일 삭제`);
    let temp = Array.from(onSubmitForm?.imgs)?.filter((val:any,id:any)=>val?.name !== name);
    setOnSubmitForm({...onSubmitForm,imgs:temp});
  }
  
  const onSubmit = async () => {
    // 유효성 검사
    if(!getValues('subject')) {
      return alert(`제목을 입력하세요`);
    }
    if(!getValues('desc')) {
      return alert(`내용을 입력하세요.`);
    }
    
    if (isSubmitting) return;
    
    setIsSubmitting(true);
    
    try {
      // 카테고리 매핑
      const categoryMap: { [key: string]: string } = {
        '0': '계정',
        '1': '결제/ 환불/ 배송',
        '2': '오류 신고',
        '3': '기타'
      };
      
      // 이미지를 Base64로 변환
      const imagePromises = onSubmitForm.imgs.map((file: File) => {
        return new Promise<string>((resolve) => {
          const reader = new FileReader();
          reader.onload = () => {
            resolve(reader.result as string);
          };
          reader.readAsDataURL(file);
        });
      });
      
      const base64Images = await Promise.all(imagePromises);
      
      // API 호출 데이터 준비
      const boardData = {
        category: categoryMap[onSubmitForm.category],
        subject: getValues('subject'),
        description: getValues('desc'),
        images: base64Images
      };
      
      console.log('게시글 작성 요청:', boardData);
      
      // API 호출
      const result = await api.createBoard(boardData);
      
      if (result.success) {
        alert(`작성이 완료되었습니다.`);
        navigate('/cs_center');
        window.location.reload();
      } else {
        alert(`작성에 실패했습니다: ${result.message}`);
      }
      
    } catch (error) {
      console.error('게시글 작성 오류:', error);
      alert(`작성 중 오류가 발생했습니다. 다시 시도해주세요.`);
    } finally {
      setIsSubmitting(false);
    }
  }
  
  useEffect(() => {
    getReady();
  }, []);
  
  useEffect(() => {
    if (!formState?.isDirty) return;
    console.warn(`뒤로가기 가능`)
    const sentinel = { __block__: Date.now() };
    window.history.pushState(sentinel, "");
    const onPop = () => {
      setShow(true);
      window.history.pushState(sentinel, "");
    };
    window.addEventListener("popstate", onPop);
    return () => {
      window.removeEventListener("popstate", onPop);
    };
  }, [formState?.isDirty]);
  

  
  // console.log(watch('subject'),'/[subject]');
  // console.log(watch('desc'),'/[desc]');
  // console.warn(formState?.isDirty,'/[formState?.isDirty]');
  
  
  return (
    <>
      <div className={`section_wrap sec_wrap_2 edit_add`}>
        <div className={`sec sec_2`}>
          <div className={`form_group`}>
            {/**--------------------------------------------------카테고리---------------------------------------------**/}
            <div className={`form_group`}>
              <label className={`form_label`}>카테고리 <span className={`most`}>(필수)</span></label>
              <div className={`form_control form_select`} onClick={()=>{setSelectBox(!selectBox)}}>
                <div className={`now_select`}>{catValToTxt(onSubmitForm?.category)}</div>
                <nav className={`options ${selectBox ? `on`:``}`}>
                  {/*반복문 구간*/}
                  {option?.map((obj,idx)=>{
                    return (
                      <button key={idx} onClick={()=>onSelect(obj?.value)}>{obj?.label}</button>
                    )
                  })}
                </nav>
              </div>
            </div>
            {/**--------------------------------------------------제목---------------------------------------------**/}
            <div className={`form_group`}>
              <label className={`form_label`}>제목 <span className={`most`}>(필수)</span></label>
              <div className={`form_value`}>
                <input
                  type={`text`}
                  {...register(`subject`,{required:true})}
                  className={`form_control`}
                  placeholder={`제목을 입력해주세요.`}
                />
              </div>
            </div>
            {/**--------------------------------------------------설명---------------------------------------------**/}
            <div className={`form_group`}>
              <label className={`form_label`}>설명 <span className={`most`}>(필수)</span></label>
              <div className={`form_value`}>
                <textarea
                  {...register(`desc`,{required:true})}
                  className={`form_control`}
                  placeholder={`내용을 입력해주세요.`}
                ></textarea>
              </div>
            </div>
            {/**--------------------------------------------------사진첨부------------------------------------------**/}
            <div className={`form_group`}>
              <label className={`form_label`}>사진 첨부 <span className={`option`}>(필수)</span></label>
              <div className={`form_file`}>
                <div className={`file_wrap flex items-center`}>
                  <input
                    ref={(e) => {fileBtnRef.current = e}}
                    onChange={(e) => {
                      if (e.target.files) {
                        uploadFiles(e.target.files)
                      }
                    }}
                    type={`file`}
                    accept="image/*"
                    className={`hidden`}
                    multiple
                  />
                  {(onSubmitForm?.imgs) && (
                    <ul className={`img_box flex flex-wrap`}>
                      {/*반복문 구간*/}
                      {Array.from(onSubmitForm?.imgs)?.map((val:any,idx:any)=>{
                        let imgSrc = URL.createObjectURL(val);
                        return (
                          <li key={idx} className={`img_item`}>
                            <button className={`btn_del`} onClick={()=>onDelThum(val?.name,idx)}></button>
                            <img src={imgSrc} alt={val?.name}/>
                          </li>
                        )
                      })}
                    </ul>
                  )}
                  {(onSubmitForm?.imgs?.length < 5) && (
                    <button className={`btn btn-outline-primary`} onClick={() => fileBtnRef.current?.click()}>파일 선택</button>
                  )}
                </div>
                <p>첨부 파일은 최대 5개, 30MB까지 등록 가능합니다.</p>
              </div>
            </div>
            {/**--------------------------------------------------작성완료------------------------------------------**/}
            <div className={`btn_group`}>
              <button 
                className={`btn btn-primary w-[100%]`} 
                onClick={onSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? '작성 중...' : '작성완료'}
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modals
        show={show}
        alertType={`form_load`}
        navigate={navigate}
        onClose={(res:any)=>setShow(res)}
      />
    </>
  )
}
export default Form;